module.exports = __webpack_public_path__ + "static/media/succeed-o.f21cf438.svg";